module.exports = __webpack_public_path__ + "media/13.f8a5e4f8.mp3";